/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ConstraintVersionResource } from "./ConstraintVersionResource";
export const ConstraintVersionResponse = core.serialization.object({
    data: ConstraintVersionResource,
});
